// Importaciones
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import About from './components/About';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Contact from './components/Contact';
import { LanguageProvider } from './components/LanguageContext'; // Importa el LanguageProvider
import './App.css';

// Componente principal
const App: React.FC = () => {
  return (
    <LanguageProvider> {/* Mueve el LanguageProvider aquí para envolver toda la aplicación */}
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          {/* Puedes añadir rutas específicas para About, Projects, Skills, Contact si es necesario */}
          <Route path="/about" element={<Home />} />
          <Route path="/projects" element={<Home />} />
          <Route path="/skills" element={<Home />} />
          <Route path="/contact" element={<Home />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
};

// Componente Home que contiene todas las secciones
const Home: React.FC = () => {
  return (
    <div>
      <section id="about">
        <About />
      </section>
      <section id="proyectos">
        <Projects />
      </section>
      <section id="skills-content">
        <Skills />
      </section>
      <section id="contact-content">
        <Contact />
      </section>
    </div>
  );
};

export default App;
